
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ObjectInfoValues from './ObjectInfoValues';
import ObjectInfoTitle from './ObjectInfoTitle';
import ObjectInfoParcely from './ObjectInfoParcely';
import ObjectInfoVlastnictvi from './ObjectInfoVlastnictvi';

const classNames = mergeStyleSets({
    root: {
    }
});

const ObjectInfoTelesoDetail = (props) => {
    return (
        <React.Fragment>
            <ObjectInfoTitle title="LIST VLASTNICTVÍ" />
            <ObjectInfoValues items={[
                {
                    title: 'Katastrální území',
                    value: props.tel.katuze_nazev
                },
                {
                    title: 'Číslo LV',
                    value: props.tel.cislo_tel
                }
            ]}/>
        </React.Fragment>
    );
}

const ObjectInfoTeleso = (props) => {
    return (
        <div className={classNames.root}>
            <Stack tokens={{childrenGap: 16}}>
                <Stack.Item>
                    <ObjectInfoTelesoDetail tel={props.info.params} />
                </Stack.Item>
                <ObjectInfoVlastnictvi vla={props.info.vla} />
                <Stack.Item grow>
                    <ObjectInfoParcely
                        title="PARCELY"
                        parc={props.info.parc}
                    />
                </Stack.Item>
            </Stack>
        </div>
    );
}

export default ObjectInfoTeleso;
